module.exports = __webpack_public_path__ + "static/media/Warranty.49642074.svg";